module.exports = __webpack_public_path__ + "static/media/NCTsign.2a442110.jpeg";